//@ts-check
// TODO
const areInputsEqual = (newInputs, lastInputs) => {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (let i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }
  return true;
};

export const memoize = (resultFn) => {
  let lastThis;
  let lastArgs = [];
  let lastResult;
  let calledOnce = false;

  function memoized(...newArgs) {
    if (calledOnce && lastThis === this && areInputsEqual(newArgs, lastArgs)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  }

  return memoized;
};

export const pipe = (...fns) => (x) => fns.reduce((v, f) => f(v), x);
export const compose = (...fns) => (x) => fns.reduceRight((v, f) => f(v), x);

export const sequentialAsync = (fn) => {
  let p = Promise.resolve();
  return (...args) => {
    const res = p.then(() => fn(...args));
    p = res.catch(e => e);
    return res;
  };
};

/**
 * 
 * @param {number} ms 
 * @returns 
 */
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * @param {() => any | Promise<any>} executor 
 * @param {number} interval 
 * @param {number} retryCount 
 * @param {(d: any) => any | Promise<any>} [onSuccess]
 * @param {(e: any) => any | Promise<any>} [onFailure]
 */
export const retry = async (
  executor, 
  interval, 
  retryCount = 0,
  onSuccess = undefined,
  onFailure = undefined,
) => {
  let error = undefined;
  const totalCount = Number.isNaN(retryCount) ? 1 : (Math.max(0, retryCount) + 1);
  for (let i = 0; i < totalCount; ++i) {
    if (i !== 0)
      await sleep(interval);
    try {
      const data = await executor();
      if (onSuccess)
        await onSuccess(data);
      return;
    } catch (e) {
      error = e;
    }
  }
  if (onFailure)
    await onFailure(error);
};

/**
 * @param {() => any | Promise<any>} executor 
 * @param {number} interval 
 * @param {number} retryCount 
 */
export const useRetry = (
  executor, 
  interval, 
  retryCount = 0,
) => new Promise((res, rej) => {
  retry(executor, interval, retryCount, res, rej);
});